"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const rehype_react_1 = __importDefault(require("rehype-react"));
const unified_1 = require("unified");
const remark_parse_1 = __importDefault(require("remark-parse"));
const remark_toc_1 = __importDefault(require("remark-toc"));
const remark_rehype_1 = __importDefault(require("remark-rehype"));
const markdownComponents_1 = __importDefault(require("./markdownComponents"));
const Link_1 = __importDefault(require("../Link"));
// import Pre from "../Pre";
const DisabledLink = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Link_1.default, Object.assign({}, props, { as: "span" }), children));
};
// const FixedPre: FunctionComponent = (props) => <Pre {...props} as="span" />;
const rehype = (disabledLinks) => {
    return new rehype_react_1.default({
        createElement: react_1.createElement,
        Fragment: react_1.Fragment,
        components: Object.assign(Object.assign({}, markdownComponents_1.default), { a: disabledLinks ? DisabledLink : Link_1.default }),
    });
};
const processor = (0, unified_1.unified)()
    .use(remark_parse_1.default)
    .use(remark_toc_1.default)
    .use(remark_rehype_1.default)
    .use(rehype_react_1.default, { createElement: react_1.default.createElement, components: markdownComponents_1.default });
const Markdown = (0, react_1.forwardRef)((_a, ref) => {
    var { htmlAst, html, disabledLinks = false } = _a, rest = __rest(_a, ["htmlAst", "html", "disabledLinks"]);
    if (html) {
        const content = processor.processSync(html);
        return (react_1.default.createElement("div", Object.assign({ ref: ref }, rest), content.result));
    }
    return (react_1.default.createElement("div", Object.assign({ ref: ref }, rest), rehype(disabledLinks).Compiler(htmlAst)));
});
exports.default = Markdown;
//# sourceMappingURL=Markdown.js.map